interface getFixedSerializedFiltersOptions {
  categoryName?: string
  subcategoryName?: string
}

export function getFixedSerializedFilters(options: getFixedSerializedFiltersOptions) {
  const filters: string[] = []

  if (options.categoryName) {
    filters.push(`category:${options.categoryName}`)
  }

  if (options.subcategoryName) {
    filters.push(`subcategory:${options.subcategoryName}`)
  }

  return filters
}
